<template>
  <div
    class="news-slider"
    :class="{ bg_gray: _.get(contentData, 'conf.conf[0]') }"
  >
    <div class="news-slider__ttl container flex j_sb a_center wc-lg">
      <h2 class="f-24 bold uppercase">
        {{ _.get(contentData, "conf.header.title") }}
      </h2>
      <router-link
        :to="news_link[0].full_url"
        class="f-14 medium f-light-purple"
        >{{ $fn.tr("მაჩვენე ყველა") }}</router-link
      >
    </div>
    <div class="news-slider__inner container">
      <swiper :options="swiperOptions">
        <swiper-slide
          :key="index"
          v-for="(story, index) in content"
          class="news-slider__slide br-12 flex column bg-gray"
        >
          <img
            :src="story.slider_image[0].url"
            class="cover"
            :alt="
              $route.name == 'PageViewRouter_ge' && story.seo_keywords_ge
                ? story.seo_keywords_ge
                : $route.name == 'PageViewRouter_en' && story.seo_keywords_en
                ? story.seo_keywords_en
                : ''
            "
          />
          <router-link
            :to="$store.getters['main/getSingleUrl'](story)"
            class="news-slider__text-box flex column wc-lg"
          >
            <h2 class="f-18 bold uppercase">{{ story.title }}</h2>
            <h3 class="f-13 medium">{{ story.teaser }}</h3>
          </router-link>
          <router-link
            :to="
              $store.state.main.indx.menus.filter(menu =>
                menu.configs.includes(check_tag(story.news_category[0]).slug)
              )[0].full_url
            "
            class="news-slider__tag wc-lg br-6 bg-white pointer flex a_center"
            :class="{
              tag_news: check_tag(story.news_category[0]).slug == 'news'
            }"
          >
            <h2 class="f-12 bold">
              {{ check_tag(story.news_category[0]).title }}
            </h2>
          </router-link>
        </swiper-slide>
      </swiper>
    </div>

    <div class="news-slider__scrollbar flex j_sb container">
      <div class="news-slider__scrollbar--line"></div>
      <div class="news-slider__navigation flex">
        <div class="news-slider__prev pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_2500"
              data-name="Group 2500"
              transform="translate(-13 -12.801)"
            >
              <g
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                transform="translate(13 12.801)"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175.342a1.167,1.167,0,0,0,0,1.65l3.842,3.842H1.166a1.167,1.167,0,0,0,0,2.334h8.85L6.175,12.008a1.167,1.167,0,1,0,1.65,1.65l5.834-5.833.02-.021.01-.01.01-.01.012-.013.007-.008.013-.015.005-.006.014-.017,0-.005.014-.018,0,0,.013-.018,0,0,.013-.018,0-.006.012-.018,0-.007.01-.016.005-.009.008-.014.007-.012.006-.011.009-.016,0-.007.011-.021v0a1.166,1.166,0,0,0-.24-1.359L7.825.342a1.167,1.167,0,0,0-1.65,0Z"
                  transform="translate(14 14) rotate(180)"
                  fill="#7063e9"
                />
              </g>
            </g>
          </svg>
        </div>

        <div class="news-slider__next pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_2499"
              data-name="Group 2499"
              transform="translate(-13 -12.801)"
            >
              <g
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                transform="translate(13 12.801)"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                  fill="#7063e9"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 30,
        grabCursor: true,
        speed: 800,
        watchOverflow: true,
        resistanceRatio: 0,
        scrollbar: {
          el: ".news-slider__scrollbar--line",
          draggable: true,
          hide: false,
          dragSize: 350,
          snapOnRelease: false
        },
        navigation: {
          nextEl: ".news-slider__next",
          prevEl: ".news-slider__prev"
        },
        breakpoints: {
          //  1919: {
          //   slidesOffsetBefore: 165,
          //   slidesOffsetAfter: 164,
          // },
          1206: {
            slidesOffsetBefore: 45,
            slidesOffsetAfter: 45
          },
          1023: {
            slidesOffsetBefore: 45,
            slidesOffsetAfter: 45
          },
          767: {
            spaceBetween: 10,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 17,
            scrollbar: {
              dragSize: 137
            }
          }
        },
        on: {
          touchMove() {
            if (
              document.querySelectorAll(".news-slider .swiper-slide").length >=
              2
            ) {
              document
                .querySelectorAll(".news-slider .swiper-slide")
                .forEach(slide => {
                  slide.style.transform = "scale(0.9, 0.9)";
                });
            }
          },
          touchEnd() {
            if (
              document.querySelectorAll(".news-slider .swiper-slide").length >=
              2
            ) {
              document
                .querySelectorAll(".news-slider .swiper-slide")
                .forEach(slide => {
                  slide.style.transform = "scale(1, 1)";
                });
            }
          }
        },
        pagination: {}
      }
    };
  },
  computed: {
    main_title() {
      return _.get(this.contentData, "conf.header.title");
    },
    content() {
      let list = _.get(this.contentData, "data.list");
      if (this.$store.state.main.selected_business) {
        list = list.filter(
          L =>
            L.insurance &&
            L.insurance.includes(this.$store.state.main.selected_business)
        );
        if (list.length == 0) list = _.get(this.contentData, "data.list");
      } else {
        list = _.get(this.contentData, "data.list");
      }
      return list;
    },
    news_link() {
      let menu = this.$store.state.main.indx.menus;
      return menu.filter(m => m.configs.includes("news"));
    }
  },
  mounted() {},

  methods: {
    check_tag(tag_id) {
      let tag = this.$store.state.main.indx.terms.news_category.filter(
        tag => tag.id == tag_id
      );
      return tag[0];
    }
  }
};
</script>
